import syncDocumentTypes from "../../constants/syncDocumentTypes";

const getEntityTypeForDocument = (syncSettings, documentOrFolder, rootFolderId, depthBelowRoot) => {
  const isDocumentType = documentOrFolder === syncDocumentTypes.TEXT;
  const isFolderType =
    documentOrFolder === syncDocumentTypes.FOLDER ||
    documentOrFolder === syncDocumentTypes.DRAFT_FOLDER ||
    documentOrFolder === syncDocumentTypes.RESEARCH_FOLDER;
  const isOtherType = !isDocumentType && !isFolderType;

  if (isOtherType) {
    return null;
  }

  const folder = syncSettings.entityFolders.get(rootFolderId);
  if (folder.flattened) {
    return depthBelowRoot === 0 ? folder.mainType : null;
  }

  if (depthBelowRoot < folder.levels.size) {
    const l = folder.levels.get(depthBelowRoot);
    const value = isDocumentType ? l.documentType : l.folderType;
    return value;
  }
  const value = isDocumentType ? folder.defaultDocumentType : folder.defaultFolderType;
  return value;
};

export default getEntityTypeForDocument;
